import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface QueryRequest {
  companyFrom: string;  // 公司代號篩選下限
  companyTo: string;    // 公司代號篩選上限
  yearMonFrom: string;  // 年度月份篩選下限 YYYY/MM
  yearMonTo: string;    // 年度月份篩選上限 YYYY/MM
  deptFrom: string;     // 部門代號篩選下限
  deptTo: string;       // 部門代號篩選上限
  salesFrom: string;    // 業務代號篩選下限
  salesTo: string;      // 業務代號篩選上限
  reportType: string;   // "dept" | "company" | "both"
}

export interface ARMonthlyRow {
  deptCode: string;
  deptName: string;
  company: string;
  salesCode: string;
  salesName: string;
  yearMonth: string;
  currency: string;
  amount1: number;
  amount2: number;
}

export interface DeptCompanySummary {
  deptCode: string;
  deptName: string;
  company: string;
  currency: string;
  amount1: number;
  amount2: number;
}

export interface DeptSummary {
  deptCode: string;
  deptName: string;
  currency: string;
  amount1: number;
  amount2: number;
}

export interface CompanySummary {
  company: string;
  currency: string;
  amount1: number;
  amount2: number;
}

export interface CurrencyTotal {
  currency: string;
  amount1: number;
  amount2: number;
}

export interface QueryResponse {
  details: ARMonthlyRow[];
  deptCompanySummary?: DeptCompanySummary[];
  deptSummary?: DeptSummary[];
  companySummary?: CompanySummary[];
  currencyTotals: CurrencyTotal[];
  totalCount: number;
}

export interface LookupResult {
  code: string;
  name: string;
}

// ============================================================
// API Client
// ============================================================

export const g303Api = {
  async query(req: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post('/api/g303/query', req);
    return res.data;
  },

  async lookup(type: string, code: string): Promise<LookupResult> {
    const res = await apiClient.get(`/api/g303/lookup/${type}/${encodeURIComponent(code)}`);
    return res.data;
  },
};
